var React = require('react');

function RightArrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"className":"nc-icon-wrapper","fill":"#fff"},React.createElement("path",{"d":"M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"})));
}

RightArrow.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = RightArrow;

RightArrow.default = RightArrow;
